import React, { useEffect, useRef, useState } from 'react';
import { supabaseClient } from '../../services/supabase';
import { useScrollFadeIn } from '../../utils/scrollFadeIn';

// デフォルトの店舗写真
const defaultPhotos = {
  counter: { title: 'カウンター', image_url: '/images/counter.jpg' },
  koagari: { title: '小上がり', image_url: '/images/zashiki.jpg' }
};

function StoreInfo() {
  const sectionRef = useRef(null);
  const [photos, setPhotos] = useState(defaultPhotos);

  useEffect(() => {
    loadPhotos();
  }, []);

  const loadPhotos = async () => {
    try {
      const { data, error } = await supabaseClient
        .from('store_photos')
        .select('*')
        .eq('is_visible', true);

      if (error) throw error;

      if (data && data.length > 0) {
        const photoMap = { ...defaultPhotos };
        data.forEach(photo => {
          photoMap[photo.photo_type] = {
            title: photo.title,
            image_url: photo.image_url
          };
        });
        setPhotos(photoMap);
      }
    } catch (error) {
      console.error('店舗写真の読み込みエラー:', error);
      // エラー時はデフォルト画像を使用
    }
  };

  useScrollFadeIn(sectionRef, '.photo-item', [photos]);

  return (
    <section id="store" className="store" ref={sectionRef}>
      <div className="container">
        <h2 className="section-title">店舗情報</h2>
        
        <div className="store-info">
          <table className="info-table">
            <tbody>
              <tr>
                <th>店名</th>
                <td>よし鮨</td>
              </tr>
              <tr>
                <th>住所</th>
                <td>〒071-8143 北海道旭川市春光台３条３丁目９−２５</td>
              </tr>
              <tr>
                <th>電話番号</th>
                <td><a href="tel:0166-53-3032">0166-53-3032</a></td>
              </tr>
              <tr>
                <th>営業時間</th>
                <td>11:00〜22:00（L.O. 21:00）</td>
              </tr>
              <tr>
                <th>定休日</th>
                <td>月（月が祝日の場合は火。詳細はカレンダーをご確認ください）</td>
              </tr>
              <tr>
                <th>席数</th>
                <td>カウンター7席、小上がり3卓<br />※全席禁煙</td>
              </tr>
              <tr>
                <th>お支払方法</th>
                <td>現金、クレジットカード可（Visa/Master/JCB/AMEX ほか）</td>
              </tr>
            </tbody>
          </table>
        </div>
        
        <div className="store-photos">
          {photos.counter && (
            <div className="photo-item fade-in">
              <img src={photos.counter.image_url} alt={photos.counter.title} />
              <p>{photos.counter.title}</p>
            </div>
          )}
          {photos.koagari && (
            <div className="photo-item fade-in">
              <img src={photos.koagari.image_url} alt={photos.koagari.title} />
              <p>{photos.koagari.title}</p>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}

export default StoreInfo;

